import { render, staticRenderFns } from "./FeedbackEdit.vue?vue&type=template&id=766804d6"
import script from "./FeedbackEdit.vue?vue&type=script&lang=ts"
export * from "./FeedbackEdit.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackEdit.vue?vue&type=style&index=0&id=766804d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports